import { render, staticRenderFns } from "./TqChat_messages.vue?vue&type=template&id=5f245651&scoped=true&"
import script from "./TqChat_messages.vue?vue&type=script&lang=js&"
export * from "./TqChat_messages.vue?vue&type=script&lang=js&"
import style0 from "./TqChat_messages.vue?vue&type=style&index=0&id=5f245651&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f245651",
  null
  
)

export default component.exports